import { render, staticRenderFns } from "./UpdateQuestion.vue?vue&type=template&id=263499bb&scoped=true&"
import script from "./UpdateQuestion.vue?vue&type=script&lang=js&"
export * from "./UpdateQuestion.vue?vue&type=script&lang=js&"
import style0 from "./UpdateQuestion.vue?vue&type=style&index=0&id=263499bb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "263499bb",
  null
  
)

export default component.exports